export type StatusPillVariant = "on_track" | "attention_needed";

const LABELS: Record<StatusPillVariant, string> = {
  on_track: "No prazo",
  attention_needed: "Atenção necessária",
};

// Word-Carries-State per DESIGN.md §10.9: full word in canonical color,
// weight 600, no pill / no fill / no border / no dot / no glyph.
export function StatusPill({ value }: { value: StatusPillVariant }) {
  const isOnTrack = value === "on_track";
  return (
    <span
      data-testid={`status-pill-${value}`}
      className={
        isOnTrack
          ? "text-[13px] font-semibold text-[hsl(var(--forest-pulse))]"
          : "text-[13px] font-semibold text-[hsl(var(--amber-state))]"
      }
    >
      {LABELS[value]}
    </span>
  );
}
